/**
 * Permission constants
 * Centralized permission keys for consistent usage across the app
 */

export const PERMISSIONS = {
  // Product
  PRODUCT: {
    INDEX: 'product.index',
    CREATE: 'product.create',
    UPDATE: 'product.update',
    DELETE: 'product.delete',
    SHOW: 'product.show',
  },

  // User
  USER: {
    INDEX: 'user.index',
    CREATE: 'user.create',
    UPDATE: 'user.update',
    DELETE: 'user.delete',
    SHOW: 'user.show',
    UPDATE_USER_CREDENTIALS: 'user.updateUserCredentials',
    UPDATE_CREDENTIALS: 'user.updateCredentials',
  },

  // Role
  ROLE: {
    INDEX: 'role.index',
    CREATE: 'role.create',
    UPDATE: 'role.update',
    DELETE: 'role.delete',
    SHOW: 'role.show',
  },

  // Brand
  BRAND: {
    INDEX: 'brand.index',
    CREATE: 'brand.create',
    UPDATE: 'brand.update',
    DELETE: 'brand.delete',
    SHOW: 'brand.show',
  },

  // Banner
  BANNER: {
    INDEX: 'banner.index',
    CREATE: 'banner.create',
    UPDATE: 'banner.update',
    DELETE: 'banner.delete',
    SHOW: 'banner.show',
  },

  // Category
  CATEGORY: {
    INDEX: 'category.index',
    CREATE: 'category.create',
    UPDATE: 'category.update',
    DELETE: 'category.delete',
    SHOW: 'category.show',
  },

  // Order
  ORDER: {
    INDEX: 'order.index',
    CREATE: 'order.create',
    UPDATE: 'order.update',
    DELETE: 'order.delete',
    SHOW: 'order.show',
  },

  // Agent
  AGENT: {
    INDEX: 'agent.index',
    CREATE: 'agent.create',
    UPDATE: 'agent.update',
    DELETE: 'agent.delete',
    SHOW: 'agent.show',
    RESET_PASSWORD: 'agent.reset-password',
  },

  // Courier
  COURIER: {
    INDEX: 'courier.index',
    CREATE: 'courier.create',
    UPDATE: 'courier.update',
    DELETE: 'courier.delete',
    SHOW: 'courier.show',
    RESET_PASSWORD: 'courier.reset-password',
  },

  // Courier task
  COURIER_TASK: {
    INDEX: 'courier-task.index',
    SHOW: 'courier-task.show',
    PAYMENT_ACCEPT: 'courier-task.payment-accept',
    RETURN_ACCEPT: 'courier-task.return-accept',
  },

  // Kassa
  KASSA: {
    INDEX: 'kassa.index',
    ACCEPT: 'kassa.accept',
  },

  // Pack
  PACK: {
    INDEX: 'pack.index',
    CREATE: 'pack.create',
    UPDATE: 'pack.update',
    DELETE: 'pack.delete',
    SHOW: 'pack.show',
  },

  // Staff
  STAFF: {
    INDEX: 'staff.index',
    CREATE: 'staff.create',
    UPDATE: 'staff.update',
    DELETE: 'staff.delete',
    SHOW: 'staff.show',
    RESET_PASSWORD: 'staff.reset-password',
  },

  // Task
  TASK: {
    INDEX: 'task.index',
    CREATE: 'task.create',
    UPDATE: 'task.update',
    DELETE: 'task.delete',
    SHOW: 'task.show',
  },

  // Warehouse
  WAREHOUSE: {
    INDEX: 'warehouse.index',
    CREATE: 'warehouse.create',
    UPDATE: 'warehouse.update',
    DELETE: 'warehouse.delete',
    SHOW: 'warehouse.show',
  },

  // Purchase
  PURCHASE: {
    INDEX: 'purchase.index',
    CREATE: 'purchase.create',
    SHOW: 'purchase.show',
  },

  // Geo-zone
  GEO_ZONE: {
    INDEX: 'geo-zone.index',
    CREATE: 'geo-zone.create',
    UPDATE: 'geo-zone.update',
    DELETE: 'geo-zone.delete',
    SHOW: 'geo-zone.show',
  },

  // Agent geo-zone
  AGENT_GEO_ZONE: {
    INDEX: 'agent-geo-zone.index',
    CREATE: 'agent-geo-zone.create',
    UPDATE: 'agent-geo-zone.update',
    DELETE: 'agent-geo-zone.delete',
    SHOW: 'agent-geo-zone.show',
  },

  // Company
  COMPANY: {
    INDEX: 'company.index',
    SHOW: 'company.show',
    LIMIT_UPDATE: 'company.limit-update',
    CURRENT_AMOUNT_FILL: 'company.current-amount-fill',
  },

  // Application
  APPLICATION: {
    INDEX: 'application.index',
  },

  // Partner
  PARTNER: {
    INDEX: 'partner.index',
    CREATE: 'partner.create',
    UPDATE: 'partner.update',
    DELETE: 'partner.delete',
    SHOW: 'partner.show',
    RESET_PASSWORD: 'partner.reset-password',
  },
} as const;

export type Permission =
  (typeof PERMISSIONS)[keyof typeof PERMISSIONS][keyof (typeof PERMISSIONS)[keyof typeof PERMISSIONS]];
